import type { Dag, Dagdeel, Lesmoment, Lesreeks, Week, ZetbareWeekStatus } from './groep-types'
import type { Sleutels } from './semester-types'
import type { WeekStatus } from './semester-types'

export const DAG_VOLGORDE: Dag[] = ['ma', 'di', 'wo', 'do', 'vr']

export const DAG_LABEL: Record<Dag, string> = {
  ma: 'maandag',
  di: 'dinsdag',
  wo: 'woensdag',
  do: 'donderdag',
  vr: 'vrijdag',
}

export const DAGDEEL_VOLGORDE: Dagdeel[] = ['ochtend', 'middag']

export const DAGDEEL_LABEL: Record<Dagdeel, string> = {
  ochtend: 'ochtend',
  middag: 'middag',
}

export function lesmomentActiefIn(lesmoment: Lesmoment, maandag: string): boolean {
  if (lesmoment.vanafMaandag !== null && maandag < lesmoment.vanafMaandag) return false
  if (lesmoment.totMaandag !== null && maandag > lesmoment.totMaandag) return false
  return true
}

export function actieveLesmomenten(lesmomenten: Lesmoment[], maandag: string): Lesmoment[] {
  return lesmomenten.filter((lesmoment) => lesmomentActiefIn(lesmoment, maandag))
}

export function telLesweken(weken: Week[]): number {
  return weken.filter((week) => week.status === 'les' && week.inVenster).length
}

export function berekenLesreeksUren(lesreeks: Lesreeks, sleutels: Sleutels | null): number | null {
  if (!sleutels) return null

  const perDagdeel = sleutels.urenPerDagdeel * (1 + sleutels.opslagFactor)

  return lesreeks.weken.reduce((som, week) => {
    if (week.status !== 'les' || !week.inVenster) return som
    return som + actieveLesmomenten(lesreeks.lesmomenten, week.maandag).length * perDagdeel
  }, 0)
}

export function berekenMentoraatUren(lesreeks: Lesreeks, sleutels: Sleutels | null): number | null {
  if (!sleutels) return null

  return lesreeks.weken.reduce((som, week) => {
    if (week.status !== 'les' || !week.inVenster) return som
    const heeftMentor = actieveLesmomenten(lesreeks.lesmomenten, week.maandag).some(
      (lesmoment) => lesmoment.isMentor,
    )
    return heeftMentor ? som + sleutels.mentoraatUrenPerLesweek : som
  }, 0)
}

export function isKlikbaar(status: WeekStatus): boolean {
  return status !== 'vakantie'
}

export function volgendeWeekstatus(status: WeekStatus, inhaal = false): ZetbareWeekStatus | null {
  if (status === 'vakantie') return null
  if (inhaal) return status === 'inhaal' ? 'les' : 'inhaal'
  return status === 'les' || status === 'inhaal' ? 'geen' : 'les'
}
